import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle}</title>
                    <meta name="description" content="Welcome to Bryan Kenneth's Personal Website. Let's connect and share some ideas!" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
